import FooterSectionImages from "./FooterSectionImages";
import CurrentNews from "./CurrentNews";
import RecentlyUpdatedFiles from "./RecentlyUpdatedFiles";

const Footer = () => {
  return (
    <footer className="flex justify-between px-5 pt-5 pb-2.5 mt-20 !w-full flex-col lg:flex-row!">
      <section className="lg:!w-[31%] !w-[100%]">
        <CurrentNews />
      </section>
      <section className="lg:!w-[31%] !w-[100%]">
        <RecentlyUpdatedFiles />
      </section>
      <section className="!w-[33%] !w-[100%] !px-3">
        <FooterSectionImages />
      </section>
    </footer>
  );
};
export default Footer;
